export default __webpack_public_path__ + "text-emotion517097.png";